import stringifyObject from 'stringify-object';
import { getPriceDetailFragment } from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
type Options = {
  attendees: Array<LightAttendee>;
  duration: number;
  selectedRate: string;
};
export const getBookingAccommodationsSearch = (
  appContext: AppContext,
  id: string,
  options: Options,
) => {
  const body = [
    {
      attendees: options.attendees,
    },
  ];
  return `query {
  bookingAdditionalAccommodations(bookingId: "${id}", body: ${stringifyObject(body, {
    singleQuotes: false,
  })}
  ) {
    totalDifferentialPrice(selectedRate: "${options.selectedRate}") {
      ...priceDetails
      currency
    }
    differentialPriceByNight(
      nightsNumber: ${options.duration}, 
      selectedRate: "${options.selectedRate}"
    ) {
      formattedValue(precision: 0)
      value
    }
    isUpgradableOnline
    accommodations {
      attendeesDistribution {
        attendees {
          birthdate
          customerId
          id
          type
        }
        id
        quantity
      }
      bathroomEquipments {
        id
        label
      }
      categories {
        id
        label
      }
      category
      categoryId
      comfortType
      connectingRoom
      description
      equipments {
        id
        label
      }
      exclusiveCollection
      floorPlans
      id
      label

      maxCapacity
      media {
        photos {
          url
        }
      }
      minCapacity
      occupancies {
        baby_count
      }
      occupation
      outsideFacilities {
        id
        label
      }
      quantity
      reducedMobilityAccess
      roomType
      services {
        id
        label
      }
      strengths {
        id
        label
      }
      surface
      view {
        id
        label
      }
    }
    id
    remainingStock
  }
}
${getPriceDetailFragment(appContext?.locale)}
`;
};
